import { z } from 'zod';

export const configSchema = z.object({
  app: z.object({
    env: z
      .enum(['localhost', 'development', 'production'])
      .default('localhost'),
    apiBaseUrl: z.string().url(),
    featureFlagOverrides: z.string().optional(),
  }),
  billing: z.object({
    workspacePlanOverride: z.enum(['free', 'source', 'managed']).optional(),
  }),
  external: z.object({
    googleClientId: z.string(),
    linkedinClientId: z.string().min(1),
    linkedinRedirectUri: z.string().url(),
    // The Finlay bot's Slack app (finlay-api `Slack:ClientId`). Optional: without
    // both, the "Sign in with Slack" button stays hidden (`isSlackSsoConfigured`).
    slackClientId: z.string().min(1).optional(),
    slackRedirectUri: z.string().url().optional(),
    posthogKey: z.string(),
    posthogHost: z.string().url(),
    stiggPublishableKey: z.string(),
  }),
});
